import React from "react";
import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  SUCCESS: "bg-emerald-50 text-emerald-700 border-emerald-500",
  PENDING: "bg-amber-50 text-amber-700 border-amber-500",
  FAILED: "bg-red-50 text-red-700 border-red-500",
  CANCELLED: "bg-slate-100 text-slate-600 border-slate-300",
};

export default function StatusPill({ status }) {
  const cls = STATUS_STYLES[status] || STATUS_STYLES.CANCELLED;
  return (
    <span
      data-testid={`status-pill-${(status || "").toLowerCase()}`}
      className={cn(
        "inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-semibold border",
        cls
      )}
    >
      {status || "—"}
    </span>
  );
}
